import { getEnumValues } from "@utils/enum-utils";
import { Dayjs } from "dayjs";
import _ from "lodash";



export enum OnboardingGetStartedStep {
	GET_STARTED_EXERCISES = "GET_STARTED_EXERCISES",
	GET_STARTED_PROGRAMS = "GET_STARTED_PROGRAMS",
	GET_STARTED_PATIENTS = "GET_STARTED_PATIENTS",
}

export const onboardingGetStartedSteps = getEnumValues(OnboardingGetStartedStep);

export enum OnboardingType {
	GET_STARTED = "GET_STARTED",
	PROGRAM_QUICKSTART = "PROGRAM_QUICKSTART",
}

export type OnboardingSteps<T> = {
	step: T;
	date: Dayjs;
}[];

export type OnboardingStatus = {
	[OnboardingType.GET_STARTED]: OnboardingSteps<OnboardingGetStartedStep>;
	[OnboardingType.PROGRAM_QUICKSTART]: OnboardingSteps<OnboardingProgramQuickstartStep>;
};

export type OnboardingStep =
	| OnboardingGetStartedStep
	| OnboardingProgramQuickstartStep;

export enum OnboardingStepStatus {
	AVAILABLE = "Available",
	PENDING = "Pending",
	DISMISSED = "Dismissed",
	DISMISSED_BUT_DISPLAYED = "DismissedButDisplayed",
}

export type OnboardingStepsStatus = Record<OnboardingStep, OnboardingStepStatus>;

export const extractOnboardingTypeFromStep = (step: OnboardingStep): OnboardingType => {
	if (_.indexOf(onboardingProgramQuickstartSteps, step as OnboardingProgramQuickstartStep) !== -1) {
		return OnboardingType.PROGRAM_QUICKSTART;
	}
	return OnboardingType.GET_STARTED;
};

// Program Builder Quickstart steps
export enum OnboardingProgramQuickstartStep {
	ADD_EXERCISE_GUIDE_01 = "PROGRAM_QUICKSTART_ADD_EXERCISE_GUIDE_01",
	FILTER_LIBRARY_GUIDE_01 = "PROGRAM_QUICKSTART_FILTER_LIBRARY_GUIDE_01",
	FILTER_LIBRARY_GUIDE_02 = "PROGRAM_QUICKSTART_FILTER_LIBRARY_GUIDE_02",
	COMPLEMENTARY_EXERCISES_GUIDE_01 = "PROGRAM_QUICKSTART_COMPLEMENTARY_EXERCISES_GUIDE_01",
	COMPLEMENTARY_EXERCISES_GUIDE_02 = "PROGRAM_QUICKSTART_COMPLEMENTARY_EXERCISES_GUIDE_02",
	COMPLEMENTARY_EXERCISES_GUIDE_03 = "PROGRAM_QUICKSTART_COMPLEMENTARY_EXERCISES_GUIDE_03",
	ALTERNATIVE_EXERCISES_GUIDE_01 = "PROGRAM_QUICKSTART_ALTERNATIVE_EXERCISES_GUIDE_01",
	ALTERNATIVE_EXERCISES_GUIDE_02 = "PROGRAM_QUICKSTART_ALTERNATIVE_EXERCISES_GUIDE_02",
	ALTERNATIVE_EXERCISES_GUIDE_03 = "PROGRAM_QUICKSTART_ALTERNATIVE_EXERCISES_GUIDE_03",

	DUPLICATE_SESSION_GUIDE_01 = "PROGRAM_QUICKSTART_DUPLICATE_SESSION_GUIDE_01",
	DUPLICATE_SESSION_GUIDE_02 = "PROGRAM_QUICKSTART_DUPLICATE_SESSION_GUIDE_02",
	START_TEMPLATE_GUIDE_01 = "PROGRAM_QUICKSTART_START_TEMPLATE_GUIDE_01",
	START_DRAFT_GUIDE_01 = "PROGRAM_QUICKSTART_START_DRAFT_GUIDE_01",
	START_GUIDE_02 = "PROGRAM_QUICKSTART_START_GUIDE_02",
}

export const onboardingProgramQuickstartSteps = getEnumValues(OnboardingProgramQuickstartStep);
